import React, { FunctionComponent } from "react";
import { useMemo, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import {
  fetchCallLogs,
  fetchUserCallLogs,
  fetchLeadDistributions,
  filterValuesLeadDistribution,
  countleadDistributionNew
} from "../../Services/contacts";
import { useTable, useSortBy, useFilters, useColumnOrder } from "react-table";
import TopBar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import Loading from "../../Components/Loading/Loading";
import { LEAD_DISTRIBUTOR_COLUMNS, LEAD_DISTRIBUTOR_COLUMNS_REAL } from "../../Values/tables";
import { searchCallLogs } from "../../Values/utils";
import CustomTable from "../../Components/CustomTable/CustomTable";
import DistributionModel from "../../Components/Modals/DistributionModel/DistributionModel";
import styles from '../Analytics/Analytics.module.css';
import { themeColors } from "../../Components/theme";
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import { url } from "../../Values/constants";
import axios from "axios"
import { showSnackbarAction,  setCurrentRoute } from "../../Redux/actions";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics } from "../../Services/users";
import { useLocation } from "react-router-dom";

type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  theme: any;
  organizationData: any;
  authToken: any;
  filterObject: any;
  filterSort: any;
};
let isFinished = false;
const LeadDistributor: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  theme,
  organizationData,
  authToken,
  filterObject,
  filterSort
}) => {
  // const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [filterData1, setFilterData1] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [load, setLoad] = useState(false);
  const [searchedItem, setsearchedItem] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [count, setCount] = useState<any>(0);
  const dispatcher = useDispatch();
  const [isGACalled, setIsGACalled] = useState<any>(false);
     const [cRoute,setCRoute]=useState("") 
           const location: any = useLocation();                    
                              useEffect(() => {
                                dispatcher(setCurrentRoute(location.pathname))
                                setCRoute(location.pathname)
                              }, [location]);
  // useEffect(() => {
  //   if (user.organization_id) {
  //     const unsub = fetchLeadDistributions(user.organization_id, (data) =>
  //       setFilterData(data)
  //     );

  //     return () => {
  //       unsub();
  //     };
  //   }
  // }, [user]);

  // console.log("nfnurnvurnvurnvur",filterObject)
  // console.log("gvrbvbvbevbebvebvbv",filterSort)
  const convertToFilterString = (filterObject: { [key: string]: any }): string => {
    const filters: { [key: string]: any[] } = {};

    Object.keys(filterObject).forEach((val) => {
      if (filterObject && filterObject[val].length > 0) {
        filters[val] = filterObject[val];
      }
    });



    return JSON.stringify(filters);
  };

  const fetchLeadDistributionsNew = async (
    paginate?: boolean,
    localPageSize?: number,
    localPage?: number
  ) => {
    let initialRequestFailed = false;
    try {
      let records = localPageSize ? localPageSize : pageSize;
      let pages = localPage ? localPage : page + 1;
      let sorts = Object.keys(filterSort).length === 0 ? JSON.stringify({ created_at: -1 }) : JSON.stringify(filterSort);
      const filter: string = convertToFilterString(filterObject);

      let apiData: any = {
        organization_id: user.organization_id,
        page: pages,
        limit: pageSize,
        sort: sorts,
        filters: filter
      };

      setLoad(true);

      // axios.defaults.headers.common['x-access-token'] = authToken;
      const res = await axiosHandler.get(url + '/leadDistribution/fetchAll', {
        params: apiData,
      });

      let data: any = res.data.data;


      // count of the logics present in the organization 
      setCount(res.data.count);

      if ((data.length < records && paginate) || (data.length < records && page === 0)) {
        isFinished = true;
        setLastPage(page);
      }

      data.forEach((lead: any) => {
        for (const key in lead) {
          if (Array.isArray(lead[key])) {
            lead[key] = lead[key].join(',');
          }
        }
      });

      if (paginate && filterData1) {
        let newData = [...filterData1, ...data];
        setFilterData1(newData);
        setLoad(false);
      } else {
        setFilterData1(data);
        setLoad(false);
      }
    } catch (error) {
      setFilterData1([]);

      // Check if it's an initial request and ignore the error
      if (page === 0 && !initialRequestFailed) {
        initialRequestFailed = true; // Set the flag to true after the first failure
        console.warn('Ignoring initial bad request.');
      } else {
        // Handle the error for subsequent requests
        setLoad(false);
        dispatcher(showSnackbarAction('Please Try Again!!', 'error'));
      }
    }
  };

  useEffect(() => {
    if (user === undefined || user.organization_id === undefined) {
      return;
    }

    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if (authToken) {
      fetchLeadDistributionsNew(false, pageSize, 1);
    }
  }, [
    user.organization_id,
    authToken,
    pageSize,
    filterObject,
    filterSort,
    organizationUsers
  ]);

  useEffect(() => {

    // console.log("f3f4f",page,pageSize)
    if (
      filterData1 &&
      filterData1.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if (authToken) {
          fetchLeadDistributionsNew(false, pageSize);
        }
      } else {
        if (authToken) {
          fetchLeadDistributionsNew(true, pageSize);
        }
      }
    }

  }, [page, pageSize, authToken, user.organization_id, filterObject, filterSort, organizationUsers]);


  // useEffect(() => {
  //   if (authToken) {
  //     countleadDistributionNew(
  //       user.organization_id,
  //       (data) => setLoad(data),
  //       authToken,
  //       dispatcher,
  //       (data) => setCount(data),
  //       convertToFilterString(filterObject)
  //     );
  //   }
  // }, [user.organization_id, authToken, filterObject])


  useEffect(() => {
    if (authToken) {
      filterValuesLeadDistribution(user.organization_id, authToken, dispatcher);
    }

  }, [authToken, user.organization_id])

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Lead_Distribution_Screen',user)
      }
    }
  },[user])

  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: "0px", ...containerStyles }}>
        {load === true && <Loading />}
        <div className={styles.topBar} style={{ marginTop: "0px", ...containerStyles }}>
          <TopBar
            history={history}
            title={"Lead Distribution"}
            path={"/addContacts"}
            onChange={(val) => setsearchedItem(val)}
            filterText={"Status"}
            setColumnModal={(data) => setColumnModal(data)}
            show={false}
            showStatusBox={false}
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px", ...containerStyles }}>
          {/* {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
        <CustomTable
          tableColumns={LEAD_DISTRIBUTOR_COLUMNS_REAL}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="LeadDistributor"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setSearchedItem={(val) => setsearchedItem(val)}
        />:
        <CustomTable
          tableColumns={LEAD_DISTRIBUTOR_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="LeadDistributor"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setSearchedItem={(val) => setsearchedItem(val)}
        />
        } */}

          {(!organizationData.business_domain || organizationData.business_domain == "Real Estate") ?
            <ApiCustomTable
              tableColumns={LEAD_DISTRIBUTOR_COLUMNS_REAL}
              tableRows={filterData1}
              selectedRows={selectedRows}
              setSelectedRows={(data) => setSelectedRows(data)}
              tableType="LeadDistributor"
              showColumnModal={columnModal}
              hideColumnModal={() => setColumnModal(false)}
              selectedRowsData={selectedRowsData}
              setSelectedRowsData={(data) =>
                setSelectedRowsData(data)
              }
              setPage={(val) => setPage(val)}
              setPageSize={(val) => setPageSize(val)}
              callApi={() => Promise.resolve()}
              pageSize={pageSize}
              page={page}
              isFinished={isFinished}
              totalCount={count}
              lastPage={lastPage}
            /> :
            <ApiCustomTable
              tableColumns={LEAD_DISTRIBUTOR_COLUMNS}
              tableRows={filterData1}
              selectedRows={selectedRows}
              setSelectedRows={(data) => setSelectedRows(data)}
              tableType="LeadDistributor"
              showColumnModal={columnModal}
              hideColumnModal={() => setColumnModal(false)}
              selectedRowsData={selectedRowsData}
              setSelectedRowsData={(data) =>
                setSelectedRowsData(data)
              }
              setPage={(val) => setPage(val)}
              setPageSize={(val) => setPageSize(val)}
              callApi={() => Promise.resolve()}
              pageSize={pageSize}
              page={page}
              isFinished={isFinished}
              totalCount={count}
              lastPage={lastPage}
            />
          }
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    authToken: state.user.authToken,
    filterObject: state.leadDistributionFilter,
    filterSort: state.leadDistributionSort,
  };
};
export default connect(mapStateToProps)(LeadDistributor);
